<template>
  <div class="container">
    <el-container> 
        <el-header height="100px">
            <img src="static/image/banner1.jpg" alt="banner" class="banner-section" >
        </el-header>
        <el-main>
            <!-- 步骤条 -->
            <el-steps :active="0" process-status="process" align-center class="m-t-20">
                <el-step title="產業嘉賓注册"></el-step>
                <el-step title="資料稽核"></el-step>
                <el-step title="交費"></el-step>
                <el-step title="交費確認"></el-step>
            </el-steps>

            <!-- 公司信息表单 -->
            <el-card class="box-card">
                <div slot="header" class="t-a-left">
                    <span>公司信息</span>
                </div>
                <el-form label-width="120px" :rules="rules" ref="ruleForm" :model="FormData">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="公司名稱" label-width="auto" prop="name">
                                <el-input placeholder="請輸入公司名稱" v-model="FormData.name" maxlength="100"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="公司地址" label-width="auto" prop="address">
                                <el-input placeholder="請輸入公司地址" v-model="FormData.address" maxlength="200"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="所在國家/城市" label-width="auto" prop="country">
                                <el-input placeholder="請輸入所在國家/城市" v-model="FormData.country" maxlength="100"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="公司業務" label-width="auto" prop="business">
                                <el-input placeholder="請輸入公司業務" v-model="FormData.business" maxlength="200"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="聯繫人" label-width="auto" prop="contact">
                                <el-input placeholder="請輸入聯繫人" v-model="FormData.contact" maxlength="100"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="職務" label-width="auto" prop="position">
                                <el-input placeholder="請輸入職務" v-model="FormData.position" maxlength="100"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="聯繫電話" label-width="auto" prop="phone">
                                <el-input placeholder="請輸入聯繫電話" v-model="FormData.phone" maxlength="100"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="聯繫郵箱" label-width="auto" prop="email">
                                <el-input placeholder="請輸入聯繫郵箱" v-model="FormData.email" maxlength="100"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-form-item label="公司簡介" label-width="auto" prop="profile">
                                <el-input type="textarea" :autosize="{ minRows: 2}" placeholder="請輸入公司簡介" v-model="FormData.profile"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-form-item>
                                <el-button type="primary" @click="submitForm('ruleForm')" disabled>提交</el-button>
                                <el-button @click="resetForm('ruleForm')">重設</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>
            
        </el-main>
    </el-container>
    <!-- 左侧导航栏 -->
    <!-- <el-aside width="200px">
      <el-menu :default-active="activeMenu" class="el-menu-vertical-demo">
        <el-menu-item index="1">
          <i class="el-icon-s-home"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-s-platform"></i>
            <span>产业嘉宾</span>
          </template>
          <el-menu-item index="2-1">产业嘉宾注册</el-menu-item>
          <el-menu-item index="2-2">产业嘉宾证件申报</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">
            <i class="el-icon-s-flag"></i>
            <span>展会</span>
          </template>
        </el-submenu>
        <el-menu-item index="4">
          <i class="el-icon-user"></i>
          <span slot="title">My Page</span>
        </el-menu-item>
      </el-menu>
    </el-aside> -->

  </div>
</template>

<script>
  import setting from '@/setting'
  import {submitGuest} from '@/api/guest'
export default {
    data() {
        return {
            activeMenu: '2-1',
            FormData: {
                type:'industry',
                name: '',
                address: '',
                country: '',
                business: '',
                contact: '',
                position: '',
                phone: '',
                email: '',
                profile: ''
            },
            rules: {
                name: [
                    { required: true, message: '請輸入公司名稱', trigger: 'blur' },
                    { min: 1,max: 100, message: '100个字以内', trigger: 'blur' }
                ],
                address: [
                    { required: true, message: '請輸入公司地址', trigger: 'blur' }
                ],
                country: [
                    { required: true, message: '請輸入所在國家/城市', trigger: 'blur' }
                ],
                business: [
                    { required: true, message: '請輸入公司業務', trigger: 'blur' }
                ],
                contact: [
                    { required: true, message: '請輸入聯繫人', trigger: 'blur' }
                ],
                position: [
                    { required: true, message: '請輸入職務', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '請輸入聯繫電話', trigger: 'blur' }
                ],
                email: [
                    { required: true, message: '請輸入聯繫郵箱', trigger: 'blur' }
                ],
                profile: [
                    { required: true, message: '請輸入公司簡介', trigger: 'blur' }
                ]
            },
        };
    },
    methods: {
        submitForm(formName) {
            return false;
            this.$refs[formName].validate((valid) => {
            if (valid) {
                // 显示提交确认对话框
                this.$confirm('確認提交資料嗎？ <br>   Do you want to confirm and submit your application? ', '確認提交 Confirm Submission', {
                    confirmButtonText: '確認 Confirm',
                    cancelButtonText: '取消 Cancel',
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                    // 用户点击确认
                    this.processSubmit()
                }).catch(() => {
                    // return
                })
            } else {
                return false;
            }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        async processSubmit () {
            // 显示加载状态
            const loading = this.$loading({
                lock: true,
                text: '資料提交中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            try {
                submitGuest(this.FormData).then(res => {
                    if (loading) {
                        loading.close()
                    }
                    if (res.status==200) {
                        this.$confirm(res.msg, '資料提交成功。Submission Successful.', {
                            confirmButtonText: '確認 Confirm',
                            cancelButtonText: '',
                            type: 'success',
                            showCancelButton: false,
                            dangerouslyUseHTMLString: true
                        }).then(() => {
                            // 用户点击确认
                            this.resetForm('ruleForm')
                        }).catch(() => {
                            // return
                        })
                    } else {
                        // 提交失败
                        this.$message.error(res.msg || '提交失敗，請稍後重試。Submission Failed. Please try again later.')
                    }
                }).catch (error=> {      
                    if (loading) {
                        loading.close()
                    }
                    // 提交失败
                    this.$message.error(error.msg || '提交失敗，請檢查網絡連接。Submission Failed. Please check your network connection.')
                }) 
                // // 发送提交请求
                // const response = await fetch(`${setting.apiBaseURL}/submit_guest`, {
                //     method: 'POST',
                //     headers: {
                //     'Content-Type': 'application/json'
                //     },
                //     body: JSON.stringify(this.FormData)
                // })
                // const result = await response.json()
                // // 关闭加载状态
                // loading.close()
        
                // if (result.status==200) {
                //     // 提交成功
                //     this.$message.success('資料提交成功。Submission Successful.')
                //     // 可以选择跳转到成功页面或重置表单
                //     // this.$router.push('/success')
                //     // 或者重置表单
                //     this.resetForm('ruleForm')
                // } else {
                //     // 提交失败
                //     this.$message.error(result.msg || '提交失敗，請稍後重試。Submission Failed. Please try again later.')
                // }
            } catch (error) {
                // 关闭加载状态
                if (loading) {
                    loading.close()
                }
                console.error('提交失敗:', error)
                this.$message.error('提交失敗，請檢查網絡連接後重試。Submission Failed. Please check your network connection and try again later.')
            }
        },
    }
};
</script>

<style scoped>
.container {
    width: 100%;
    /* height: 100vh; 占满全屏 */
    display: flex;
    overflow: hidden;
    background: #f5f8ff; /* 全页面背景色 */
    scrollbar-width: none; /* Firefox */
}
.container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Edge */
}
.el-header{
    padding: 0;
}
.banner-section{
    width: 100%;
}
/* 样式部分 */
.el-aside {
  background-color: #f5f7fa;
}

.el-main {
    padding: 20px;
    margin: 20px;
    background-color: white; /* 表单部分背景色 */
    padding: 20px; /* 添加内边距以确保内容与边缘有间距 */
    border-radius: 30px; /* 圆角效果 */
}
.box-card{
    margin:30px 50px;
}
.el-card__body{
    padding: 20px;
}
.t-a-left{
    text-align: left;
}
.m-t-20{
    margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/guest/industry/register.vue